import moduleDataManagement from './data-management';
import moduleOss from './oss';
import moduleCommands from './commands';

export default {
  namespaced: true,
  modules: {
    dataManagement: moduleDataManagement,
    oss: moduleOss,
    commands: moduleCommands,
  },
};
